import { red } from '@material-ui/core/colors';
import { createMuiTheme } from '@material-ui/core/styles';

// A custom theme for this app
const theme = createMuiTheme({
  overrides: {
    MuiPaper: {
      root: {
        //transition: 'none !important',
      },
    },
  },
  palette: {
    primary: {
      main: '#0D4A81', // dark blue, taken from blue home background
    },
    secondary: {
      main: '#1982DD',  // mid blue, taken from blue home background
    },
    error: {
      main: red.A400,
    },
    background: {
      default: '#0D4A81',
      dashboard: 'url(/gfx/background-blue.jpg) cover no-repeat',
      image: 'linear-gradient(to bottom, rgba(255,255,255,0.5), rgba(255,255,255,0.1)), url(/gfx/background-blue.jpg) no-repeat',
    }
  },
});

export default theme;